import { ExpandMoreSharp, RemoveRedEye } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import { AccordionDetails, AccordionSummary, Button } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import { useState } from 'react';
import Modal from 'react-modal';
import { IBankAccountViewModel, IPixAccountViewModel, ISolicitationViewModel } from 'viewModels';
import { ReactComponent as IconPaidOut } from '../../assets/icons/IconPaidOut.svg';
import { ReactComponent as IconOpen } from '../../assets/icons/IconUpload.svg';
import { ReactComponent as WalletIcon } from '../../assets/icons/IconWallet.svg';
import { useAuth } from '../../context';
import {
  ExternalServiceType,
  labelPaymentStatus,
  labelSolicitationCancelationStatus,
  ModalPaymentType,
  PaymentSolicitationStatus,
  ProfileType,
  RequestsSubmittedStatus,
  SolicitationCancelationStatus,
  ServiceStatus,
  TypeCardUserSolicitation,
} from '../../types/enums';
import { Attachment } from '../Attachment';
import { BankAccounts } from '../BankAccounts';
import { CardUserSolicitation } from '../Cards/CardUserSolicitation';
import { ContentModal } from '../Modals/ModalAddObservation/styles';
import { ModalSeeWallet } from '../Modals/ModalSeeWallet';
import { ModalStatusPayment } from '../Modals/ModalStatusPayment';
import { ModalViewAccount } from '../Modals/ModalViewAccount';
import { ModalViewPix } from '../Modals/ModalViewPix';
import { PixAccounts } from '../PixAccounts';
import { Container, Content, HeaderModal } from './styles';

interface TradingSolicitationProps {
  solicitation: ISolicitationViewModel;
  isVisible: boolean;
}

export function TradingSolicitation({ solicitation, isVisible }: TradingSolicitationProps) {
  const [isOpenModalViewAccount, setIsOpenModalViewAccount] = useState(false);
  const [expandedRefuseds, setExpandedRefuseds] = useState<string | false>(false);
  const [expandedCanceleds, setExpandedCanceleds] = useState<string | false>(false);
  const [isOpenModalViewPix, setIsOpenModalViewPix] = useState(false);
  const [isOpenModalSeeWallet, setIsOpenModalSeeWallet] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [selectedAccountBank, setSelectedAccountBank] = useState<IBankAccountViewModel>(
    {} as IBankAccountViewModel,
  );
  const [selectedPix, setSelectedPix] = useState<IPixAccountViewModel>({} as IPixAccountViewModel);
  const [isOpenModalStatusPayment, setIsOpenModalStatusPayment] = useState(false);
  const { user } = useAuth();

  const handleOpenModalViewAccount = (bank: IBankAccountViewModel) => {
    setIsOpenModalViewAccount(true);
    setSelectedAccountBank(bank);
  };
  const handleOpenModalViewPix = (pix: IPixAccountViewModel) => {
    setIsOpenModalViewPix(true);
    setSelectedPix(pix);
  };

  return (
    <Container className={isVisible ? '' : 'displayNone'}>
      <Content
        id="solicitation-modal-content"
        isRow={
          solicitation.status === ServiceStatus.CONCLUED &&
          solicitation.externalServiceType !== ExternalServiceType.DEMAND
        }>
        <div className="contentAdditionalValue">
          <h1>Valor</h1>
          <p>R${solicitation.value}</p>
        </div>
        {solicitation.status === ServiceStatus.PENDING && (
          <>
            <div className="containerCorrespondent">
              <h1>Correspondentes</h1>
              <div className="containerCorrespondences">
                {solicitation.requestsSubmitted && solicitation.requestsSubmitted.length > 0 ? (
                  solicitation.requestsSubmitted.map((item) => (
                    <div className="contentCorrespondences" key={item.id}>
                      {item.status === Number(RequestsSubmittedStatus.PENDING) && (
                        <CardUserSolicitation
                          typeCardUserSolicitation={TypeCardUserSolicitation.REQUEST}
                          currentUser={item.user}
                          requestsSubmitted={item}
                        />
                      )}
                    </div>
                  ))
                ) : (
                  <div className="contentCorrespondences">
                    <p>Não há correspondentes</p>
                  </div>
                )}
              </div>
            </div>
            {(!user.collaboratorInfo ||
              user.collaboratorInfo?.profileType === ProfileType.OPERATOR) && (
              <div className="findCorrespondents">
                <Button
                  onClick={() => window.open(`/approvalsolicitation/${solicitation.id}`, '_blank')}>
                  Procurar mais correspondentes
                </Button>
              </div>
            )}
            {solicitation?.requestsSubmitted?.filter(
              (r) => r.status === Number(RequestsSubmittedStatus.REFUSED),
            ).length > 0 && (
              <Accordion
                expanded={expandedRefuseds === solicitation.id}
                onChange={(_, isExpanded) => {
                  setExpandedRefuseds(isExpanded ? solicitation.id! : false);
                }}>
                <AccordionSummary expandIcon={<ExpandMoreSharp />}>
                  <h1>Envios Rejeitados</h1>
                </AccordionSummary>
                <AccordionDetails>
                  <div className="containerCorrespondences">
                    <div className="contentCorrespondences">
                      {solicitation.requestsSubmitted
                        .filter((r) => r.status === Number(RequestsSubmittedStatus.REFUSED))
                        .map((item) => (
                          <CardUserSolicitation
                            key={item.id}
                            typeCardUserSolicitation={TypeCardUserSolicitation.NONE}
                            currentUser={item.user}
                            requestsSubmitted={item}
                          />
                        ))}
                    </div>
                  </div>
                </AccordionDetails>
              </Accordion>
            )}
            {solicitation?.requestsSubmitted?.filter(
              (r) => r.status === Number(RequestsSubmittedStatus.CANCELED),
            ).length > 0 && (
              <Accordion
                expanded={expandedCanceleds === solicitation.id}
                onChange={(_, isExpanded) => {
                  setExpandedCanceleds(isExpanded ? solicitation.id! : false);
                }}>
                <AccordionSummary expandIcon={<ExpandMoreSharp />}>
                  <h1>Envios Cancelados</h1>
                </AccordionSummary>
                <AccordionDetails>
                  <div className="containerCorrespondences">
                    <div className="contentCorrespondences">
                      {solicitation.requestsSubmitted
                        .filter((r) => r.status === Number(RequestsSubmittedStatus.CANCELED))
                        .map((item) => (
                          <CardUserSolicitation
                            key={item.id}
                            typeCardUserSolicitation={TypeCardUserSolicitation.NONE}
                            currentUser={item.user}
                            requestsSubmitted={item}
                          />
                        ))}
                    </div>
                  </div>
                </AccordionDetails>
              </Accordion>
            )}
          </>
        )}
        {solicitation.status === ServiceStatus.IN_PROGRESS && (
          <div className="containerCorrespondent">
            <h1>Correspondente</h1>
            {solicitation.correspondent ? (
              <div className="contentCorrespondences" key={solicitation.correspondent.id}>
                <div className="contentCorrespondence">
                  <CardUserSolicitation
                    typeCardUserSolicitation={TypeCardUserSolicitation.NONE}
                    currentUser={{
                      firstName: solicitation.correspondent.firstName,
                      lastName: solicitation.correspondent.lastName,
                      email: solicitation.correspondent.email,
                      cell: solicitation.correspondent.cell,
                      address: solicitation.correspondent.address,
                      id: solicitation.correspondent.id,
                      presentation: solicitation.correspondent.presentation ?? '',
                      url: solicitation.correspondent.url ?? '',
                      isVerified: solicitation.correspondent.isVerified ?? false,
                      profileType: solicitation.correspondent.profileType,
                    }}
                  />
                </div>
              </div>
            ) : (
              <div className="contentCorrespondences">
                <p>Não há correspondentes</p>
              </div>
            )}
          </div>
        )}
        {solicitation.status === ServiceStatus.CANCELED && (
          <div className="canceled">
            {solicitation.cancelationStatus !== undefined && (
              <div>
                <h1>Motivo do Cancelamento</h1>
                {Object.keys(labelSolicitationCancelationStatus)
                  .filter((s) => Number(s) === Number(solicitation.cancelationStatus))
                  .map((status) => (
                    <span key={status}>
                      {
                        labelSolicitationCancelationStatus[
                          status as unknown as SolicitationCancelationStatus
                        ]
                      }
                    </span>
                  ))}
              </div>
            )}
            {solicitation.cancelationDetails && (
              <div>
                <h1>Detalhes</h1>
                <span>{solicitation.cancelationDetails}</span>
              </div>
            )}
          </div>
        )}
        {solicitation.status === ServiceStatus.CONCLUED &&
          solicitation.externalServiceType !== ExternalServiceType.DEMAND && (
            <div className="solicitationPaymentAccounts">
              <div>
                <h1>Pagamento</h1>
                {solicitation.payment && solicitation.correspondent?.id !== user.id ? (
                  <>
                    <Button onClick={() => setIsOpenModalStatusPayment(true)}>
                      {Object.keys(PaymentSolicitationStatus)
                        .filter(
                          (p) =>
                            Number(p) === Number(solicitation.payment?.paymentSolicitationStatus),
                        )
                        .map((paymentStatus) => (
                          <p
                            key={paymentStatus}
                            className={
                              solicitation.payment?.paymentSolicitationStatus ===
                              PaymentSolicitationStatus.PAID
                                ? 'paidOut'
                                : 'unPaid'
                            }>
                            {
                              labelPaymentStatus[
                                paymentStatus as unknown as PaymentSolicitationStatus
                              ]
                            }{' '}
                            {solicitation.payment?.paymentSolicitationStatus ===
                            PaymentSolicitationStatus.PAID ? (
                              <IconPaidOut />
                            ) : (
                              <IconOpen />
                            )}
                          </p>
                        ))}
                    </Button>
                    <h1>
                      <WalletIcon /> Contas
                    </h1>
                    <div className="paymentAccountsContent">
                      <PixAccounts
                        type="correspondent"
                        runningTutorial={false}
                        onCallBack={(pix) => handleOpenModalViewPix(pix)}
                        filterAccounts={(pix) => pix.isPreferred}
                        correspondentPixAccounts={solicitation.correspondent?.wallet?.pixAccounts}
                      />
                      <BankAccounts
                        type="correspondent"
                        runningTutorial={false}
                        onCallBack={(bank) => handleOpenModalViewAccount(bank)}
                        filterAccounts={(bank) => bank.isPreferred}
                        correspondentBankAccount={solicitation.correspondent?.wallet?.bankAccounts}
                      />
                    </div>
                    <div className="containerSeeMore">
                      <Button onClick={() => setIsOpenModalSeeWallet(true)}>Ver Mais</Button>
                    </div>
                    <ModalViewAccount
                      isOpen={isOpenModalViewAccount}
                      onRequestClose={() => setIsOpenModalViewAccount(false)}
                      selectedAccount={selectedAccountBank}
                    />
                    <ModalViewPix
                      isOpen={isOpenModalViewPix}
                      onRequestClose={() => setIsOpenModalViewPix(false)}
                      selectedPix={selectedPix}
                    />
                    <ModalSeeWallet
                      isOpen={isOpenModalSeeWallet}
                      onRequestClose={() => setIsOpenModalSeeWallet(false)}
                      correspondentWallet={solicitation.correspondent?.wallet}
                    />
                    <ModalStatusPayment
                      isOpen={isOpenModalStatusPayment}
                      onRequestClose={() => setIsOpenModalStatusPayment(false)}
                      selectedPayment={solicitation.payment}
                      type={ModalPaymentType.UPDATE_PAYMENT}
                    />
                  </>
                ) : (
                  Object.keys(PaymentSolicitationStatus)
                    .filter(
                      (p) => Number(p) === Number(solicitation.payment?.paymentSolicitationStatus),
                    )
                    .map((paymentStatus) => (
                      <p
                        key={paymentStatus}
                        className={
                          solicitation.payment?.paymentSolicitationStatus ===
                          PaymentSolicitationStatus.PAID
                            ? 'paidOut'
                            : 'unPaid'
                        }>
                        {labelPaymentStatus[paymentStatus as unknown as PaymentSolicitationStatus]}
                        {solicitation.payment?.paymentSolicitationStatus ===
                          PaymentSolicitationStatus.PAID && (
                          <Button onClick={() => setIsOpenModal(true)}>
                            <RemoveRedEye />
                          </Button>
                        )}
                      </p>
                    ))
                )}
              </div>
            </div>
          )}
      </Content>

      <Modal
        isOpen={isOpenModal}
        overlayClassName="react-modal-overlay"
        className="react-chat-modal-content"
        onRequestClose={() => setIsOpenModal(false)}>
        <div className="containerModal">
          <HeaderModal>
            <h1>Comprovante de pagamento</h1>
            <div className="close-div">
              <button type="button" onClick={() => setIsOpenModal(false)}>
                <CloseIcon fontSize="small" />
              </button>
            </div>
          </HeaderModal>
          <ContentModal>
            <Attachment
              data={{
                id: solicitation.payment?.paymentDocumentId,
                type: solicitation.payment?.paymentDocument?.contentType ?? '',
                name: solicitation.payment?.paymentDocument?.name ?? 'Sem nome',
              }}
              options={{
                disableDelete: true,
              }}
            />
          </ContentModal>
        </div>
      </Modal>
    </Container>
  );
}
